const plusIcon = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.577 2.346h1.769v20.231h-1.769z" fill="#106695" stroke="#106695" stroke-width="0.865385" />
        <path d="M2.346 11.577h20.231v1.769H2.346z" fill="#106695" stroke="#106695" stroke-width="0.865385" />
    </svg>
);

export default plusIcon;
